<template>
  <div class="content-wrap">
    <header class="content-header cf">
      <h3>{{ $t('containers.containerPictures') }}</h3>
      <div class="header-meta">
        <Link
          :to="`/company/containers/${$route.params.container_uuid}/images/new`"
          class="button button-green button-small button-round"
          >{{ $t('containers.addPicture') }}</Link
        >
      </div>
    </header>
    <div v-if="containerData.images && containerData.images.length > 0" class="content-body">
      <Table>
        <template #header>
          <th>{{ $t('meta.image') }}</th>
          <th>{{ $t('meta.addedOn') }}</th>
        </template>
        <template #body>
          <tr v-for="(image, index) in containerData.images" :key="`c-image-${index}`">
            <td><ImageComponent :preview="image.preview_url" :src="image.url" :height="'100'" /></td>
            <td>{{ formattedFromDateTime(image.created_at) }}</td>
          </tr>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import ImageComponent from '@/components/Image.vue'
import Table from '@/components/Table/index.vue'
import dateUtils from '@/components/mixins/dateUtils'

export default {
  name: 'CompanyContainerImages',
  props: {
    container: {
      type: Object,
      required: true,
    },
  },
  components: {
    Table,
    ImageComponent,
  },
  data() {
    return {
      containerData: this.container,
    }
  },
  mixins: [dateUtils],
  watch: {
    container: {
      immediate: true,
      handler(newVal) {
        this.containerData = newVal
      },
      deep: true,
    },
  },
}
</script>
